import { Injectable } from '@angular/core';
import { WebServiceEndpoints } from '@common/web-service-endpoints';
import LiveChatAccessTokenResponse from './models/live-chat-access-token-response';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@common/services/config/config.service';

export const CC_TOKEN_KEY = 'contactCenterToken';
export const CC_REFRESH_TOKEN_KEY = 'contactCenterRefreshToken';
export const CC_TOKEN_EXPIRE_TIME_KEY = 'contactCenterTokenExpireTime';

@Injectable()
export class TokenService {
  private _expireTime: number;
  private _contactCenterToken: string;
  private _contactCenterRefreshToken: string;

  constructor(private http: HttpClient, private configService: ConfigService) {}

  public async refreshTwilioLiveChatToken(identity: string): Promise<{ twilioToken: string }> {
    const response = await this.http
      .post<LiveChatAccessTokenResponse>(WebServiceEndpoints.LiveChat.getAccessToken, {
        Identity: identity,
      })
      .toPromise();
    return { twilioToken: response.TwilioToken };
  }

  public setContactCenterToken(token: string): void {
    const expireTime = this.configService.authSettings.TokenTimeout * 1000 + Date.now() - 5 * 60 * 1000;
    this._contactCenterToken = token;
    this._expireTime = expireTime;
    sessionStorage.setItem(CC_TOKEN_KEY, token);
    sessionStorage.setItem(CC_TOKEN_EXPIRE_TIME_KEY, expireTime.toString());
  }

  public setContactCenterRefreshToken(token: string): void {
    this._contactCenterRefreshToken = token;
    sessionStorage.setItem(CC_REFRESH_TOKEN_KEY, token);
  }

  public get contactCenterToken(): string {
    if (!this._contactCenterToken) {
      this._contactCenterToken = sessionStorage.getItem(CC_TOKEN_KEY);
    }
    return this._contactCenterToken;
  }

  public get contactCenterRefreshToken(): string {
    if (!this._contactCenterRefreshToken) {
      this._contactCenterRefreshToken = sessionStorage.getItem(CC_REFRESH_TOKEN_KEY);
    }
    return this._contactCenterRefreshToken;
  }

  public removeContactCenterToken(): void {
    sessionStorage.removeItem(CC_TOKEN_KEY);
    sessionStorage.removeItem(CC_REFRESH_TOKEN_KEY);
    sessionStorage.removeItem(CC_TOKEN_EXPIRE_TIME_KEY);
    this._contactCenterToken = null;
    this._expireTime = null;
  }

  public isContactCenterTokenExpired(): boolean {
    return this.expireTime <= Date.now();
  }

  private get expireTime(): number {
    if (!this._expireTime) {
      const savedExpireTime = sessionStorage.getItem(CC_TOKEN_EXPIRE_TIME_KEY);
      if (savedExpireTime) {
        this._expireTime = parseInt(savedExpireTime);
      }
    }
    return this._expireTime;
  }
}
